import { projectsapi } from "utilities/Axios";

export const getSolutions = (id: string) => {
  return projectsapi.get(`/api/o/${id}/Solution/my-solution`);
};

export const getCurrentSolution = (oid: string, sid: string) => {
  return projectsapi.get(`/api/o/${oid}/Solution/${sid}`);
};

export const getProfileSolutions = (oid: string) => {
  return projectsapi.get(`/api/o/${oid}/Profile/my-solutions`);
};

export const getProfileProducts = (oid: string) => {
  return projectsapi.get(`/api/o/${oid}/Profile/my-products`);
};


export const getSolutionStatus = (oid: string, solutionId: string) => {
  return projectsapi.get(`/api/o/${oid}/Solution/check-solution-status?id=${solutionId}`);
};

export const getSolutionUsersWithRoles = async (organizationId: string, solutionId: string) => {
  return projectsapi.get(`/api/o/${organizationId}/o/${solutionId}/user-solution/users-with-roles`);
};

export const getAvailableUsers = async (organizationId: string, solutionId: string) => {
  return projectsapi.get(`/api/o/${organizationId}/o/${solutionId}/user-solution/users-available-to-map`);
};

export const mapUserToSolution = async (organizationId: string, solutionId: string, data: { userId: string; role: string }) => {
  return projectsapi.put(`/api/o/${organizationId}/o/${solutionId}/user-solution/map-user`, data);
};

export const unmapUserFromSolution = async (organizationId: string, solutionId: string, data: { userId: string }) => {
  return projectsapi.put(`/api/o/${organizationId}/o/${solutionId}/user-solution/unmap-user`, data);
};


export const postSolution = (id: string, data: any) => {
  return projectsapi.post(`/api/o/${id}/Solution/add-solution`, data);
};

export const editSolution = (id: string, solutionId: string, data: any) => {
  return projectsapi.put(`/api/o/${id}/Solution/${solutionId}`, data);
};

export const removeSolution = (id: string, solutionId: string) => {
  return projectsapi.delete(`/api/o/${id}/Solution/${solutionId}`);
};